
export const CRN_VALIDATION_RULES: Record<string, { regex: RegExp; descriptionKey: string; descriptionDefault: string }> = {
  BEL: { regex: /^\d{10}$/, descriptionKey: 'crnFormat.digits10', descriptionDefault: '10 digits' },
  BGR: { regex: /^\d{9}(\d{4})?$/, descriptionKey: 'crnFormat.digits9or13', descriptionDefault: '9 or 13 digits' },
  HRV: { regex: /^\d{11}$/, descriptionKey: 'crnFormat.digits11', descriptionDefault: '11 digits' },
  CZE: { regex: /^\d{8}$/, descriptionKey: 'crnFormat.digits8', descriptionDefault: '8 digits' },
  DNK: { regex: /^\d{8}$/, descriptionKey: 'crnFormat.digits8', descriptionDefault: '8 digits' },
  EST: { regex: /^\d{8}$/, descriptionKey: 'crnFormat.digits8', descriptionDefault: '8 digits' },
  FRA: { regex: /^\d{9}$/, descriptionKey: 'crnFormat.digits9', descriptionDefault: '9 digits' },
  GRC: { regex: /^\d{12}$/, descriptionKey: 'crnFormat.digits12', descriptionDefault: '12 digits' },
  IRL: { regex: /^\d{1,6}$/, descriptionKey: 'crnFormat.digits1to6', descriptionDefault: '1–6 digits' },
  ITA: { regex: /^\d{11}$/, descriptionKey: 'crnFormat.digits11', descriptionDefault: '11 digits' },
  LVA: { regex: /^\d{11}$/, descriptionKey: 'crnFormat.digits11', descriptionDefault: '11 digits' },
  LTU: { regex: /^\d{9}$/, descriptionKey: 'crnFormat.digits9', descriptionDefault: '9 digits' },
  NLD: { regex: /^\d{8}$/, descriptionKey: 'crnFormat.digits8', descriptionDefault: '8 digits' },
  POL: { regex: /^\d{10}$/, descriptionKey: 'crnFormat.digits10', descriptionDefault: '10 digits' },
  PRT: { regex: /^\d{9}$/, descriptionKey: 'crnFormat.digits9', descriptionDefault: '9 digits' },
  ROU: { regex: /^\d{2,10}$/, descriptionKey: 'crnFormat.digits2to10', descriptionDefault: '2–10 digits' },
  SVK: { regex: /^\d{8}$/, descriptionKey: 'crnFormat.digits8', descriptionDefault: '8 digits' },
  SVN: { regex: /^\d{8}$/, descriptionKey: 'crnFormat.digits8', descriptionDefault: '8 digits' },
  SWE: { regex: /^\d{10}$/, descriptionKey: 'crnFormat.digits10', descriptionDefault: '10 digits' },
  AUT: { regex: /^\d{1,6}[a-zA-Z]$/, descriptionKey: 'crnFormat.digitsAndLetter', descriptionDefault: 'digits + letter' },
  CYP: { regex: /^HE\d{6}$/, descriptionKey: 'crnFormat.heAndDigits', descriptionDefault: 'HE + 6 digits' },
  FIN: { regex: /^\d{7}-\d$/, descriptionKey: 'crnFormat.finFormat', descriptionDefault: '7 digits + dash + digit' },
  DEU: { regex: /^[A-Z]{2,4}\d+$/, descriptionKey: 'crnFormat.lettersAndDigits', descriptionDefault: 'letters + digits' },
  HUN: { regex: /^\d{2}-\d{2}-\d{6}$/, descriptionKey: 'crnFormat.hunFormat', descriptionDefault: 'digits in format XX-XX-XXXXXX' },
  LUX: { regex: /^[A-Z]\d+$/, descriptionKey: 'crnFormat.letterAndDigits', descriptionDefault: 'letter + digits' },
  MLT: { regex: /^C\d+$/, descriptionKey: 'crnFormat.cAndDigits', descriptionDefault: 'C + digits' },
  ESP: { regex: /^[A-Z]\d{7}[A-Z0-9]$/, descriptionKey: 'crnFormat.espFormat', descriptionDefault: 'letter + 7 digits + letter/digit' },
};

export const validateCrn = (crn: string, country: string): boolean => {
  const rule = CRN_VALIDATION_RULES[country?.toUpperCase()];
  if (!rule) return true;
  return rule.regex.test(crn);
};

export const getCrnFormatDescription = (
  country: string,
  tr: (key: string, defaultValue: string) => string,
): string | undefined => {
  const rule = CRN_VALIDATION_RULES[country?.toUpperCase()];
  if (!rule) return undefined;
  return tr(rule.descriptionKey, rule.descriptionDefault);
};